import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import "./task-ready-for-approval.scss";

const TaskReadyForApproval = ({ show, onHide, setReadyStatus, labels }) => {
  const [showModal, setShowModal] = useState(show ?? false);

  return (
    <Modal show={showModal} onHide={onHide} className="task-ready-for-approval">
      <Modal.Header className="ready-for-approval-modal-header">
        <Modal.Title className="ready-for-approval-modal-title">Ready For Approval?</Modal.Title>
      </Modal.Header>
      <Modal.Body className="task-approval-popup">
        <div className="icon-warning"></div>
        <h3 className="text-confirm">
          Is this {labels?.TaskSingular ?? 'task'} ready for approval?
        </h3>
        <div className="button-row">         
          <Button onClick={(e) => { onHide(e); setReadyStatus(false) }} className="btn-large btn-outlined ">
            No
          </Button>
          <Button onClick={(e) => { onHide(e); setReadyStatus(true) }} className="btn-large">
            Yes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TaskReadyForApproval;
